import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  ${props =>
    props.fullScreen
      ? css`
          height: 100vh;
          position: relative;
          display: flex;
        `
      : css`
          position: sticky;
          bottom: 50%;
          display: none;
        `}
  justify-content: center;
  align-items: center;
  z-index: 5;
`;

Wrapper.defaultProps = {
  fullScreen: true,
};

export default Wrapper;
